import MailView from "components/view/join/email/mail";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

export default function EmailPage() {
  const { t } = useTranslation();

  const emlRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <MailView emlRef={emlRef} />
    </>
  );
}
